import { render, staticRenderFns } from "./root_app.vue?vue&type=template&id=2622bdbe"
import script from "./root_app.vue?vue&type=script&lang=js"
export * from "./root_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports